import React from 'react'
import { View } from 'components/View'

export default function FormGroup ({
  align,
  ...rest
}) {
  return (
    <View
      mt
      style={{
        alignItems: align,
        width: '100%'
      }}
      {...rest}
    />
  )
}
